import { Switch } from '@/global/components/Switch'
import { TextField } from '@/global/components/TextField'
import { cn } from '@/lib/utils'
import localeText from '@/locales/datagrid'
import { insensitive } from '@acme/common'
import { Button } from 'global/components/Button'
import { SearchIcon } from 'lucide-react'
import React from 'react'
import { mostrarTodas } from '../utils/columnVisibilityStorage'
import { useTableApiContext } from '../utils/table-context'

export default function ColumnVisibility() {
    const { columns, setColunas, resetColunas } = useTableApiContext()

    const colunasFiltraveis = columns.filter(c => c.hideable !== false)
    const [colunasPesquisa, setColunasPesquisa] = React.useState(
        colunasFiltraveis.map(c => c.field),
    )

    return (
        <div
            className={cn(
                'flex flex-row items-start p-2.5 w-full gap-x-2.5',
                'overflow-x-auto h-[150px] overflow-y-hidden',
                'border-1 border-b-0',
            )}
        >
            <div
                className={cn(
                    'flex-1 grid gap-2 p-2',
                    'grid-cols-[repeat(auto-fill,minmax(250px,1fr))]',
                    'grid-rows-[fit-content] max-h-full',
                    'overflow-y-auto overflow-wrap-break-word',
                    'float-left h-fit mr-2.5',
                )}
            >
                {colunasFiltraveis
                    .filter(c => colunasPesquisa.includes(c.field))
                    .map(column => {
                        return (
                            <Switch
                                fullWidth
                                key={column.field}
                                checked={!column.hide}
                                onChange={event => {
                                    const value = event.target.checked
                                    setColunas(
                                        columns.map(c =>
                                            c.field === column.field
                                                ? {
                                                      ...c,
                                                      hide: !value,
                                                  }
                                                : c,
                                        ),
                                    )
                                }}
                                label={column.headerName ?? column.field}
                                containerClassName="px-2 py-1"
                            />
                        )
                    })}
            </div>
            <div
                className={cn(
                    'w-[200px] float-right flex flex-col justify-evenly h-full',
                )}
            >
                <TextField
                    placeholder={localeText.columnsPanelTextFieldLabel}
                    size="small"
                    variant="outlined"
                    autoComplete="off"
                    unHelperText
                    startAdornment={<SearchIcon className="size-5" />}
                    onChange={event => {
                        const value = event.target.value
                        setColunasPesquisa(
                            colunasFiltraveis
                                .filter(c =>
                                    insensitive(
                                        c.headerName ?? c.field,
                                    ).includes(insensitive(value)),
                                )
                                .map(c => c.field),
                        )
                    }}
                    className="mb-2"
                />
                <div className="flex flex-row gap-1">
                    <Button
                        variant="outlined"
                        className="flex-1 min-w-0"
                        onClick={() => {
                            setColunas(prev => mostrarTodas(prev))
                        }}
                    >
                        {localeText.columnsPanelShowAllButton}
                    </Button>
                    <Button
                        variant="outlined"
                        className="flex-1 min-w-0"
                        onClick={() => {
                            setColunas(prev =>
                                prev.map(c => {
                                    if (c.hideable !== false)
                                        return {
                                            ...c,
                                            hide: true,
                                        }
                                    return c
                                }),
                            )
                        }}
                    >
                        {localeText.columnsPanelHideAllButton}
                    </Button>
                </div>
                <Button
                    variant="outlined"
                    fullWidth
                    className="mt-1"
                    onClick={resetColunas}
                >
                    {localeText.columnsPanelResetButton}
                </Button>
            </div>
        </div>
    )
}
